import React, { createContext, useContext, useEffect, useState } from "react";

export const AuthContext = createContext(null);

const getStoredUser = () => {
  try {
    const stored = sessionStorage.getItem("kuddleUser");

    if (!stored || stored === "undefined" || stored === "null") {
      return null;
    }

    return JSON.parse(stored);
  } catch (err) {
    console.warn("Invalid kuddleUser in sessionStorage. Clearing it.");
    sessionStorage.removeItem("kuddleUser");
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredUser());
  const [token, setToken] = useState(() => {
    const storedToken = sessionStorage.getItem("kuddleToken");
    return !storedToken || storedToken === "undefined" || storedToken === "null"
      ? null
      : storedToken;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const restoreSession = async () => {
      const storedToken = sessionStorage.getItem("kuddleToken");

      if (!storedToken || storedToken === "undefined" || storedToken === "null") {
        sessionStorage.removeItem("kuddleToken");
        sessionStorage.removeItem("kuddleUser");
        setUser(null);
        setToken(null);
        setLoading(false);
        return;
      }

      try {
        const res = await fetch("/api/auth/me", {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (!res.ok) {
          sessionStorage.removeItem("kuddleToken");
          sessionStorage.removeItem("kuddleUser");
          setUser(null);
          setToken(null);
          setLoading(false);
          return;
        }

        const data = await res.json();

        sessionStorage.setItem("kuddleUser", JSON.stringify(data.user));
        setUser(data.user);
        setToken(storedToken);
      } catch (err) {
        console.error("Failed to restore session:", err);
        sessionStorage.removeItem("kuddleToken");
        sessionStorage.removeItem("kuddleUser");
        setUser(null);
        setToken(null);
      } finally {
        setLoading(false);
      }
    };

    restoreSession();
  }, []);

  const login = ({ user, token }) => {
    sessionStorage.setItem("kuddleUser", JSON.stringify(user));
    sessionStorage.setItem("kuddleToken", token);
    setUser(user);
    setToken(token);
  };

  const logout = () => {
    sessionStorage.removeItem("kuddleUser");
    sessionStorage.removeItem("kuddleToken");
    setUser(null);
    setToken(null);
  };

  const updateCurrentUser = (updates) => {
    setUser((prev) => {
      const updated = { ...(prev || {}), ...updates };
      sessionStorage.setItem("kuddleUser", JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        currentUser: user,
        token,
        loading,
        authLoading: loading,
        login,
        logout,
        updateCurrentUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);